import { Form } from "react-bootstrap";

import "./Switch.scss";

export type SwitchProps = Omit<React.ComponentProps<typeof Form.Switch>, "type">;

function Switch({ className = "", label, ...props }: SwitchProps) {
  const resolvedLabel = label ?? "";
  const resolvedClassName = ["switch-v2", className].filter(Boolean).join(" ");

  return <Form.Switch {...props} label={resolvedLabel} className={resolvedClassName} />;
}

export default Switch;
